import React from "react";
import "./ReviewsAverage.scss";
import ReviewProgress from "../ReviewProgress/ReviewProgress";

const ReviewsAverage = ({ rating }) => {
  // const [oneStar, setOneStar] = useState(0);
  // const [twoStar, setTwoStar] = useState(0);
  // const [threeStar, setThreeStar] = useState(0);
  // const [fourStar, setFourStar] = useState(0);
  // const [fiveStar, setFiveStar] = useState(0);

  return (
    <div className="ReviewAverage">
      <div className="mark">
        <p>{rating} av 5</p>
        <span>(38 recensioner)</span>
      </div>

      <div className="statistics">
        <div className="flex">
          <p>★★★★★</p>
          <ReviewProgress completed={0.75 * 100} />
        </div>
        <div className="flex">
          <p>★★★★</p>
          <ReviewProgress completed={0.15 * 100} />
        </div>
        <div className="flex">
          <p>★★★</p>
          <ReviewProgress completed={0.08 * 100} />
        </div>
        <div className="flex">
          <p>★★</p>
          <ReviewProgress completed={0.05 * 100} />
        </div>
        <div className="flex">
          <p>★</p>
          <ReviewProgress completed={0.05 * 100} />
        </div>
      </div>
    </div>
  );
};

export default ReviewsAverage;
